export default __webpack_public_path__ + "static/sivasspor-logo-f3acb447a7238512d52266d1d57b8fde.png";